import { Link, useLocation } from "react-router-dom";
import { MapPin, Phone, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";

export const MobileStickyCTA = () => {
  const location = useLocation();
  
  // Hide on homepage and certain pages
  const hiddenPaths = ["/", "/contact", "/cancellation", "/feedback", "/privacy", "/terms"];
  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <div className="md:hidden sticky-cta" data-testid="mobile-sticky-cta">
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          className="flex-1 border-white/20 text-white hover:bg-white/10"
          asChild
          data-testid="mobile-cta-call"
        >
          <a href="tel:+18563820555">
            <Phone className="w-4 h-4 mr-2" />
            Call
          </a>
        </Button>
        <Button 
          variant="outline" 
          className="flex-1 border-white/20 text-white hover:bg-white/10"
          asChild
          data-testid="mobile-cta-directions"
        >
          <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">
            <Navigation className="w-4 h-4 mr-2" />
            Directions
          </a>
        </Button>
        <Link to="/locations" className="flex-1">
          <Button 
            className="w-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold"
            data-testid="mobile-cta-signup"
          >
            <MapPin className="w-4 h-4 mr-2" />
            Sign Up
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
